// extracted by mini-css-extract-plugin
module.exports = {"label":"label_label___k1GF","isBold":"label_isBold__RjcuH"};